import { PropTypes } from 'prop-types';
import AccionaSimpleSpinner from '../AccionaSimpleSpinner';
import { useRef } from 'react';

const AccionaInput = ({
  label,
  state,
  onChange,
  disabled,
  size,
  type,
  loading,
}) => {
  const ref = useRef();
  return (
    <>
      <input
        ref={ref}
        autoComplete="off"
        type={type}
        id={`input-${label}`}
        disabled={disabled}
        name={label}
        value={state?.value || ''}
        onChange={(event) => {
          onChange(label, event.target.value);
        }}
        style={size === 'medium' ? { padding: '5px 10px' } : {}}
      />
      {loading && (
        <span
          style={{
            position: 'absolute',
            right: '5px',
            top: `${(ref.current?.offsetHeight || 40) / 2 + 9}px`,
          }}
        >
          <AccionaSimpleSpinner size={18} />
        </span>
      )}
    </>
  );
};

AccionaInput.propTypes = {
  label: PropTypes.string.isRequired,
  state: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'medium']),
  type: PropTypes.oneOf(['text', 'number']),
  loading: PropTypes.bool,
};

AccionaInput.defaultProps = {
  state: undefined,
  onChange: () => {},
  disabled: false,
  size: 'default',
  type: 'text',
  loading: false,
};

export default AccionaInput;
